import { faChevronCircleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { smoothScroll } from "../../utils/scrollbarUtil";
import { cleanJoin } from "../../utils/stringUtil";
import "./ScrollToTop.scss";
import { useTranslation } from "react-i18next";

function ScrollToTop({
  icon = faChevronCircleUp,
  showAfterYScrolled = 25,
  scrollToElementQuerySelector = "#root",
}) {
  const [hidden, setHidden] = useState(true);
  const [fixed, setFixed] = useState(true);

  const { t } = useTranslation();

  const onScroll = () => {
    let absolute =
      window.innerHeight + window.scrollY >
      document.body.offsetHeight - document.querySelector("footer").offsetHeight;

    absolute ? setFixed(false) : setFixed(true);

    window.scrollY > showAfterYScrolled ? setHidden(false) : setHidden(true);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  });

  return (
    <FontAwesomeIcon
      className={cleanJoin(
        `scroll-to-top-${fixed ? "fixed" : "absolute"}`,
        hidden ? "is-hidden" : "",
        "is-clickable"
      )}
      icon={icon}
      size="3x"
      onClick={() => smoothScroll(scrollToElementQuerySelector)}
      title={t("scrollToTop.title")}
    ></FontAwesomeIcon>
  );
}

export default ScrollToTop;
